import React from 'react';
import { SystemDiagram } from '../components/SystemDiagram';
export function SystemPage() {
  return <div className="min-h-screen w-full bg-[#0A0F1C] text-slate-200 flex flex-col items-center justify-center p-4 sm:p-8 pt-20 sm:pt-8" data-id="element-1250">
      <div className="w-full max-w-7xl" data-id="element-1251">
        <div className="text-center mb-6 sm:mb-8" data-id="element-1252">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4" data-id="element-1253">
            The HIRE System
          </h1>
          <p className="text-base sm:text-xl text-slate-400" data-id="element-1254">
            Visual breakdown of our recruiting system architecture
          </p>
        </div>

        <div className="w-full bg-slate-900/50 rounded-xl border border-slate-800 p-2 sm:p-4 shadow-2xl" data-id="element-1255">
          <div className="w-full h-[600px] md:h-[700px] lg:h-[800px] rounded-lg overflow-hidden bg-[#0A0F1C]" data-id="element-1256">
            <SystemDiagram data-id="element-1257" />
          </div>
        </div>
      </div>
    </div>;
}